import React, { useEffect, useState } from 'react';
import { subscribeToActiveAds } from '../firebase/firestore';
import './AdPopup.css';

export default function AdPopup() {
  const [ad, setAd] = useState(null);
  const [visible, setVisible] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (sessionStorage.getItem('popup_ad_shown')) return;
    const unsub = subscribeToActiveAds('popup', (ads) => {
      if (ads.length > 0 && !sessionStorage.getItem('popup_ad_shown')) {
        setTimeout(() => { setAd(ads[0]); setVisible(true); }, 1500);
      }
    });
    return unsub;
  }, []);

  useEffect(() => {
    if (!visible) return;
    if (countdown === 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [visible, countdown]);

  const close = () => {
    setVisible(false);
    sessionStorage.setItem('popup_ad_shown', '1');
  };

  if (!visible || !ad) return null;

  return (
    <div className="popup-overlay" onClick={close}>
      <div className="popup-box" onClick={e => e.stopPropagation()}>
        <div className="popup-header">
          <span className="popup-ad-label">Advertisement</span>
          <button className="popup-close" onClick={close} disabled={countdown > 0}>
            {countdown > 0 ? `Skip in ${countdown}s` : '✕ Close'}
          </button>
        </div>
        <a href={ad.linkURL} target="_blank" rel="noopener noreferrer" onClick={close}>
          <img src={ad.imageURL} alt={ad.title} className="popup-image" />
        </a>
        {ad.title && <p className="popup-title">{ad.title}</p>}
      </div>
    </div>
  );
}
